import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const PLUS_BADGE_I18N_NAMESPACE =
  '@mc/checkout/experiments/prcng-1109_v1_plus_badge'

export const i18nInstance = registerI18nResources({
  namespace: PLUS_BADGE_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
